<template>
  <div class="flex flex-col card">
    <div class="flex flex-row items-center justify-between">
      <DeviceName
          :show-edit="showEdit"
          :device-name="deviceName"
          :device-id="deviceId"
          :legal="legal"
          align="flex-start"
          @onUpdateDeviceName="onUpdateDeviceName"/>
      <div class="flex flex-1 flex-row items-center gap-2 justify-end" >
        <div class="radius-border vertical items-center justify-center" style="width:36px;height:36px"
            @click="onFavoriteDevice">
          <van-image
              :src="isFavorite === 1 ? require('@/assets/icons/consumer/ic_favorite_device_like.svg'): require('@/assets/icons/consumer/ic_favorite_device.svg')"/>
        </div>
        <div class="radius-border  vertical items-center justify-center" style="width:36px;height:36px" v-if="false">
          <van-image :src="require('@/assets/icons/consumer/ic_share_device.svg')" @click="onShare"/>
        </div>

      </div>
    </div>


    <div class="flex flex-row items-center justify-center w-full mt-4">
      <div class="flex-1 flex flex-col items-center">
        <van-image :style="{visibility: flavorImage ? 'visible': 'hideen' }" show-loading :src="flavorImage" width="100%"
            height="151" fit="contain"/>
      </div>
      <div class="flex flex-col items-center justify-center  text-center" style="flex:1.2">
        <div class="flavor main-color" v-if="labelTag">{{ labelTag }}</div>
        <div class="flavor main-color mt-1" v-if="flavorTag">{{ flavorTag }}</div>
        <div class="ingredient mt-2.5">{{ ingredientText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceName from "@/components/home/DeviceName.vue";

export default {
  name: "DeviceInfo",
  components: { DeviceName },
  props: {
    legal: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    deviceName: {
      type: String,
      default: ""
    },
    deviceId: {
      type: String,
      default: ""
    },
    deviceType: {
      type: String,
      default: "1" //0 bt 1 nfc 后台接口的定义
    },
    flavorTag: {
      type: String,
      default: ""
    },
    labelTag: {
      type: String,
      default: ""
    },
    flavorImage: {
      type: String,
      default: ""
    },
    isFavorite: {
      type: Number,
      default: 0
    },
    ingredientText: {
      type: String,
      default: "60% THC+30% THCA+10% TP"
    }
  },
  methods: {
    onUpdateDeviceName(content) {
      this.$emit("onUpdateDeviceName", content);
    },
    onFavoriteDevice() {
      this.$emit("onFavoriteDevice");
    },
    onShare() {
      if (navigator.canShare()) {
        navigator.share(
            {
              title: "webShare",
              text: "webShare",
              url: location.href
            }
        );
      } else {
        this.$toast({
          message: "no support share"
        });
      }
    }
  }
};
</script>


<style scoped lang="less">
.flavor {
  width: 112px;
  height: 25px;
  border-radius: 6px;
  background: #F1F6FF;
  font-size: 12px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ingredient {
  max-width: 112px;
  font-size: 10px
}

</style>